import React, { useEffect, useState } from "react";
import styled from "styled-components";

import {
  Form,
  Modal,
  ModalProps,
  SubmitButtons,
  TextInput,
} from "@examspark/common-ui";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";
import { ParsedExam, Resource, Tag } from "@examspark/types";

import { useMutationCopyExam } from "../../api/operations/exam";

const ModalBodyCopy = styled.div`
  margin-bottom: 8px;
`;

const CopyExamModal = ({
  onCopy,
  modalTitle = "Copy To My Library",
  modalBodyCopy,
  ...props
}: {
  exam?: ParsedExam;
  limitClassroomsToCourse?: string;
  onCopy?: (exam: Resource) => void;
  modalTitle?: string;
  modalBodyCopy?: React.ReactNode;
} & ModalProps) => {
  const [examCopyName, setExamCopyName] = useState(
    `${props.exam?.name} (Copy)`,
  );
  const copyExam = useMutationCopyExam();

  const handleCopy = async () => {
    const exam = props.exam;
    if (!exam) {
      console.error("No exam provided to copy");
      return;
    }

    const tags: Tag[] = [];
    if (props.limitClassroomsToCourse) {
      tags.push({
        type: "string",
        key: "course-id",
        value: props.limitClassroomsToCourse,
      });
    }

    const copyExamResult = await copyExam.mutateAsync({
      examKey: {
        id: exam?.id,
        sk: exam?.sk,
      },
      examData: {
        name: examCopyName,
        tags: tags.length ? tags : undefined,
      },
    });

    console.log("copy", copyExamResult);
    if (!copyExamResult?.exam) {
      console.error("Error copying exam");
      return;
    }

    onCopy?.(copyExamResult.exam as Resource);
  };

  useEffect(() => {
    setExamCopyName(`${props.exam?.name} (Copy)`);
  }, [props.exam]);

  return (
    <Modal
      title={modalTitle}
      buttons={
        <SubmitButtons
          isSubmitDisabled={copyExam.isLoading}
          isLoading={copyExam.isLoading}
          submitLabel="Copy Assessment"
          onSubmit={handleCopy}
          onCancel={props.onRequestClose}
        />
      }
      {...props}
    >
      <PaddedBody>
        <Form.FieldList>
          {modalBodyCopy && (
            <Form.Field>
              <ModalBodyCopy>{modalBodyCopy}</ModalBodyCopy>
            </Form.Field>
          )}
          <Form.Field label="Assessment Name">
            <TextInput
              autoFocus
              value={examCopyName}
              onChange={(e) => setExamCopyName(e.target.value)}
            />
          </Form.Field>
        </Form.FieldList>
      </PaddedBody>
    </Modal>
  );
};

export default CopyExamModal;
